import { z } from 'zod';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

const zodApprovedDecimalSchema = z.union([z.number(), z.string()]).nullable();

const zodChargeOrAllowanceApprovedPatchSchema = z.object({
  absolutePerItemApproved: zodApprovedDecimalSchema.nullish(),
  absoluteTotalApproved: zodApprovedDecimalSchema.nullish(),
  basisAmountApproved: zodApprovedDecimalSchema.nullish(),
  nameApproved: z.string().trim().nullish(),
  percentageApproved: zodApprovedDecimalSchema.nullish(),
});

export const zodUpdateLineItemApprovedPayloadSchema = z.object({
  additionalQuantityApproved: zodApprovedDecimalSchema.optional(),
  additionalUnitTypeApproved: z.string().trim().nullish(),
  allowances: z.array(zodChargeOrAllowanceApprovedPatchSchema).nullish(),
  applicableTaxApproved: z.string().trim().nullish(),
  charges: z.array(zodChargeOrAllowanceApprovedPatchSchema).nullish(),
  comment: z.string().trim().nullish(),
  grossPriceApproved: zodApprovedDecimalSchema.optional(),
  nameApproved: z.string().trim().nullish(),
  netPricePerQuantityApproved: zodApprovedDecimalSchema.optional(),
  quantityApproved: zodApprovedDecimalSchema.optional(),
  taxPercentApproved: zodApprovedDecimalSchema.optional(),
  totalApproved: zodApprovedDecimalSchema.optional(),
  unitApproved: z.string().nullable().optional(),
  unitPriceApproved: zodApprovedDecimalSchema.optional(),
});

export const zodUpdateLineItemApprovedResponseSchema = zodInvoiceDetailSchema;
